#import '../fragments/user-table-fragment.graphql'

mutation CreateUser($input: UserCreateInput!) {
    userCreate(input: $input) {
        user {
            ...UserTableFragment
        }
        isExistingUser
    }
}
